import { useTranslation } from 'react-i18next';
import './AddApproverCell.scss';
import styles from './AddApproverCell.module.scss';
import Icon from '../../../common/Icon/Icon';
import { useAppSelector } from '../../../../redux/hooks';
import { useMemo, useState } from 'react';
import { Approver, useViewRoutingContext } from '../ViewRoutingContext/ViewRoutingContext';
import SearchDropdown from '../../../common/SearchDropdown/SearchDropdown';
import { useGetUsersListQuery, UserItem } from '../../../../redux/services/hatvAwardApprovalAPI';

const AddApproverCell: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const { t } = useTranslation();
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);

  const { approvers, setApprovers, aboDetails } = useViewRoutingContext();

  const { data } = useGetUsersListQuery({ affiliateCode: aboDetails.affiliateCode });

  const usersList = useMemo(() => (data?.body ? data.body.map(mapUserItemToApprover) : []), [data]);

  const [adding, setAdding] = useState(false);
  const dropdownItems = useMemo(
    () =>
      usersList
        .filter((app) => !approvers.some((item) => item.id === app.id))
        .map((app) => ({
          code: app.id,
          value: app.name,
        })),
    [approvers, usersList]
  );

  const handleSelectApprover = (item: DropdownItem | null) => {
    if (!item) return;

    const selectedItem = usersList.find((user) => user.id === item.code);
    if (!selectedItem) return;
    setAdding(false);

    setApprovers((items) => [...items, selectedItem]);
  };

  return (
    <div className={`add_approver_cell ${styles.add_approver_cell}`}>
      {adding ? (
        <div className={`select_approver_wrapper ${styles.select_approver_wrapper}`}>
          <SearchDropdown
            key={approvers.length}
            items={dropdownItems}
            dropdownName={t('hatv_view_routing.select_approver')}
            selectedItem={null}
            handleSelectItemCallback={handleSelectApprover}
          />
        </div>
      ) : (
        <button onClick={() => setAdding(true)} disabled={disabled}>
          <Icon
            name="plus_white"
            size={14}
            color={currentTheme === 'light' ? '#2c2c2c' : '#D8D8D9'}
            className={styles.plus_icon}
          />
          <span>{t(`hatv_view_routing.add_approver`)}</span>
        </button>
      )}
    </div>
  );
};

const mapUserItemToApprover = (user: UserItem): Approver => {
  return {
    id: user.nativeId,
    deleted: false,
    designation: 'TBD',
    name: user.fullName,
    status: 0,
    date: new Date().toISOString(),
  };
};

export default AddApproverCell;
